<template lang="pug">
.container.grid-xl.py-2.manual-page
  .columns
    .column.col-12
      router-link.btn.btn-link.btn-sm(:to="{ name: 'app.manuais' }")
        i.fa.fa-arrow-left.fa-fw
        |  Voltar aos manuais

      h4.h4 Doc — Ação: Solicitar revisão e Revisar
      p.text-gray Manual do usuário · OS-m Admin v1.84+

      h5.h5 Visão geral
      p
        | Use
        strong  Solicitar revisão
        |  para pedir correção, ou
        strong  Revisar
        |  quando for o responsável pela revisão do documento.

      .toast.toast-primary
        | Solicitar revisão exige
        strong  Fiscalização → Documentos → Solicitar revisão
        | . Revisar exige
        strong  Fiscalização → Documentos → Revisar
        | .

      h5.h5 1. Abrir a ação
      ol
        li Abra o documento (
          strong Doc → Documentos → Exibir
          | ).
        li No rodapé, abra o menu
          strong  Ações
          | .
        li Clique na opção desejada.
      figure.manual-figure
        img(:src="imgMenu" alt="Menu Ações do documento")

      h5.h5 2. Solicitar revisão ou Revisar
      figure.manual-figure
        img(:src="imgModal" alt="Fluxo de revisão do documento")
      ul
        li
          strong Solicitar revisão
          |  — informe o motivo e confirme o pedido.
        li
          strong Revisar
          |  — percorra o wizard de revisão, ajuste o necessário e confirme.
      .divider
      router-link.btn.btn-primary(:to="{ name: 'app.manuais' }")
        i.fa.fa-book.fa-fw
        |  Voltar à lista de manuais
</template>

<script>
export default {
  data() {
    return {
      imgMenu: require("@/assets/manuais/14-doc-acoes-menu.png"),
      imgModal: require("@/assets/manuais/14b-doc-acao-revisao.png"),
    }
  },
}
</script>

<style lang="stylus" scoped>
.manual-page
  h5
    margin-top 1.5rem

  .manual-figure
    margin 1rem 0
    img
      max-width 100%
      height auto
      border 1px solid #e7e9ed
      border-radius 4px

  .toast
    margin 1rem 0
</style>
